'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _concat2 = require('./_internal/_concat');

var _concat3 = _interopRequireDefault(_concat2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var concat = (0, _define2.default)(_concat3.default, _INT_TWO2.default); /**
                                                                          * Returns a new array, which is a merge of at least two arrays
                                                                          *
                                                                          * @module concat
                                                                          * @func
                                                                          * @since 1.16.0
                                                                          * @param {...Array} args
                                                                          * @return {function|Array}
                                                                          * @example
                                                                          *
                                                                          *     const([1, 2], [3, 4]); //=> [1, 2, 3, 4]
                                                                          */

exports.default = concat;